/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { updateField } from '../../../actions/BookingRequest';

class RoleCardMultipleButton extends Component {
    toggleMultiple() {
        const { date, dates, isMultiple, updateField } = this.props;
        updateField('isMultiple', !isMultiple);
        if (!isMultiple) updateField('dates', [date]);
        else updateField('date', dates.sort()[0]);
    }

    render() {
        let className = 'role-multiple-button ';
        if (this.props.isMultiple) className += 'role-multiple-button-selected';
        return (
            <button
                className={className}
                onClick={this.toggleMultiple.bind(this)}
            >
                Multiple days
            </button>
        );
    }
}

function mapStateToProps(state) {
    return {
        isMultiple: state.requestData.bookingRequest.isMultiple,
        dates: state.requestData.bookingRequest.dates,
        date: state.requestData.bookingRequest.date,
    };
}

export default connect(mapStateToProps, { updateField })(
    RoleCardMultipleButton,
);
